import { Box, BoxProps, Heading, Stack, Text } from "@chakra-ui/react";

import { IMarginProps, IPaddingProps } from "src/types/types";

interface IProps extends IMarginProps, IPaddingProps {
  maxWidth?: BoxProps["maxW"];
}

const Intro: React.FC<IProps> = ({ maxWidth = "1170px", ...style }) => (
  <Box
    {...style}
    maxW={maxWidth}
    margin="0 auto"
    pt={{ base: "64px", md: "168px" }}
    h={{ base: "384px", md: "574px" }}
    px={{ base: "16px", md: "32px", xl: "unset" }}
  >
    <Stack direction="column" alignItems="flex-start" spacing={0}>
      <Heading
        as="h1"
        variant="h1_large"
        textAlign="left"
        mb="16px"
        color="ud-white"
        maxW={{ base: "100%", md: "632px" }}
      >
        Profesionální prezentace pro vaši nemovitost
      </Heading>
      <Text
        variant="large_1"
        color="ud-white"
        pb="40px"
        maxW="456px"
        fontWeight="regular"
      >
        Zvyšte zájem o inzerci pomocí našich profesionálních služeb.
      </Text>
    </Stack>
  </Box>
);
export default Intro;
